export const SESSION_EXPIRED = 'learning:session-expired'
export const SESSION_CLEARED = 'learning:session-cleared'

export class SessionExpiredError extends Error {
  constructor() {
    super('Phiên đăng nhập đã hết hạn.')
    this.name = 'SessionExpiredError'
  }
}
